import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ManualSellerPageRoutingModule } from './manual-seller-routing.module';

import { ManualSellerPage } from './manual-seller.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ManualSellerPageRoutingModule
  ],
  declarations: [ManualSellerPage],
  exports:[ManualSellerPage]
})
export class ManualSellerPageModule {}
